import { Alert, Button, Form, InputGroup } from 'react-bootstrap';
import React, { useState } from 'react';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';

const Signup = (props) => {
	const [ userName, setUserName ] = useState('');
	const [ password1, setPassword1 ] = useState('');
	const [ password2, setPassword2 ] = useState('');
	const [ showType1, setShowType1 ] = useState(false);
	const [ showType2, setShowType2 ] = useState(false);

	let auth = JSON.parse(localStorage.getItem('auth'));

	if (auth === null) {
		auth = [ { username: 'aaa', password: 'aaa' } ];
	}

	const handleSignup = () => {
		const filter = auth.filter((d) => d.username === userName);
		if (filter.length !== 0) {
			alert(userName + ' exists!');
		} else {
			if (password1 === password2) {
				if (filter.length === 0) {
					auth = [ ...auth, { username: userName, password: password1 } ];
					localStorage.setItem('auth', JSON.stringify(auth));
					localStorage.setItem('userLoggedIn', userName);
					setUserName('');
					setPassword1('');
					setPassword2('');
					props.afterSignup(userName);
					// props.user(userName);
				}
			} else {
				// <Alert variant="danger">Passwords are not matching</Alert>;
				alert('Passwords are not matching');
			}
		}
	};

	return (
		<Form style={{ padding: '5% 30% 5% 30%' }}>
			<h1>Register</h1>
			<Form.Group>
				<span style={{ margin: '5px' }} />
				<Form.Control
					type="text"
					value={userName}
					onChange={(e) => setUserName(e.target.value)}
					placeholder="Username"
				/>
			</Form.Group>
			<span style={{ margin: '5px' }} />
			<Form.Group>
				<InputGroup>
					<Form.Control
						placeholder="Password"
						type={showType1 ? 'text' : 'password'}
						value={password1}
						onChange={(e) => setPassword1(e.target.value)}
					/>
					<Button
						variant="dark"
						onClick={() => {
							setShowType1(!showType1);
						}}
					>
						{showType1 ? <FaRegEye /> : <FaRegEyeSlash />}
					</Button>
				</InputGroup>
			</Form.Group>
			<span style={{ margin: '5px' }} />
			<Form.Group>
				<InputGroup>
					<Form.Control
						placeholder="Confirm Password"
						type={showType2 ? 'text' : 'password'}
						value={password2}
						onChange={(e) => setPassword2(e.target.value)}
					/>
					<Button
						variant="dark"
						onClick={() => {
							setShowType2(!showType2);
						}}
					>
						{showType2 ? <FaRegEye /> : <FaRegEyeSlash />}
					</Button>
				</InputGroup>
			</Form.Group>
			<span style={{ margin: '5px' }} />
			<Form.Group>
				{userName && password1 && password2 !== '' ? (
					<Button variant="success" onClick={handleSignup} active>
						Signup
					</Button>
				) : (
					<Button variant="secondary" onClick={handleSignup} disabled>
						Signup
					</Button>
				)}
			</Form.Group>
		</Form>
	);
};

export default Signup;
